import React, { FC, useContext } from 'react'
import {
    TheWestLiveContext,
    TheWestLivePlayerState,
    useOnAirState,
} from '../TheWestLiveProvider'
import { FeatureToggle } from '../../../feature-toggling/Toggle/Toggle'

export interface TheWestLivePlayerProps {
    PlayerSkin: React.FC<TheWestLivePlayerSkinProps>
}

export interface TheWestLivePlayerSkinProps extends TheWestLivePlayerState {
    onControlClick: () => void
    onVolumeChange: (volume: number) => void
    onAir: boolean
}

export const TheWestLivePlayer: FC<TheWestLivePlayerProps> = ({
    PlayerSkin,
}) => {
    const { playerActions, playerState } = useContext(TheWestLiveContext)
    const { onAir } = useOnAirState()

    return (
        <FeatureToggle
            feature="the-west-live"
            on={() =>
                onAir ? (
                    <PlayerSkin
                        onAir={onAir}
                        {...playerActions}
                        {...playerState}
                    />
                ) : null
            }
        />
    )
}
